import PageLang from "./page-lang";
import DetectMobileBrowsers from "./detect-mobile-browsers";

class Pagination {
    constructor() {
        this.lang = PageLang.get();
        this.translations = {
            _0: {
                pl: "Poprzednia",
                en: "Previous"
            },
            _1: {
                pl: "Następna",
                en: "Next"
            }
        };
        this.paginationNav = $('#pagination-nav');
        this.arrowButton = $('.page-link').find('span[aria-hidden="true"]');
    }

    events() {
        const _this = this;

        //this.arrowButton.parent().on('click', function (event) {
        //    event.preventDefault();
        //
        //    if ($(this).hasClass('page-link_prev')) {
        //        _this.showPreviousPage();
        //    } else if ($(this).hasClass('page-link_next')) {
        //        _this.showNextPage();
        //    }
        //});
    }

    showPreviousPage() {
        let pageNumber = this.getActivePageNumber();
        let pageUrl = this.getPageUrl().replace(/&p=[0-9]+/g, '&p=');
        pageNumber--;

        window.location = pageUrl + pageNumber;
    }

    showNextPage() {
        let pageNumber = this.getActivePageNumber();
        let pageUrl = this.getPageUrl().replace(/&p=[0-9]+/g, '&p=');
        pageNumber++;

        window.location = pageUrl + pageNumber;
    }

    getActivePageNumber() {
        return parseInt(this.paginationNav.find('.page-item.active > .page-link').text());
    }

    getPageUrl() {
        return this.paginationNav.find('.page-item.active > .page-link').attr('data-url');
    }

    replaceArrowToLabel() {
        const isMobileBrowser = DetectMobileBrowsers.check();
        const _this = this;

        $.each(this.arrowButton, function (index, element) {
            let $parent = $(element).parents('.page-item');
            let indexOfParent = $parent.index();

            if (indexOfParent === 0) {
                $(element).text(_this.translations['_0'][_this.lang]);
                $parent.addClass('page-item_prev');
                $parent.children().addClass('page-link_prev');
            } else {
                $(element).text(_this.translations['_1'][_this.lang]);
                $parent.addClass('page-item_next');
                $parent.children().addClass('page-link_next');
            }
        });

        if (isMobileBrowser) {
            this.shrinkPagination();
        }
    }

    shrinkPagination() {
        let beforeActive = this.paginationNav.find('.page-item.active').prev();
        let nextActive = this.paginationNav.find('.page-item.active').next();

        this.paginationNav.find('.page-item').not('.page-item_prev, .page-item_next, .active').hide();
        beforeActive.show();
        nextActive.show();
    }

    init() {
        if (this.paginationNav.length > 0) {
            this.events();
            this.replaceArrowToLabel();
        }
    }
}

export default Pagination;
